import React, { Component } from "react";
import Wrp from '../../../../../../../hoc/Wrp/Wrp';
// import {Card,CardBody} from '../../../../../../../hoc/Card';
// import BootstrapRow from '../../../../../../../hoc/BootstrapRow';
// import BootstrapColumn from '../../../../../../../hoc/BootstrapColumn';
import FormInputFields from '../../../../../../FormInputFields';
// import Datetime from 'react-datetime';
import moment from 'moment';
// import 'react-datetime/css/react-datetime.css';
import {getDateFormat} from '../../../../../../../Utils/UserFunctions';
import StepsFormatTag from '../StepsFormatTag';
import { isSet } from "../../../../../../../Utils/CommonFunctions";


class OnDateOption extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dt: moment(),
      setDt: moment(),
      isReminderPopup:false,
      isReminderSelected:false
    }
  }
  render() {
    const  {
      reminderJson,
      attr,
    } = this.props;
    // console.log(reminderJson);
    let dateValue = reminderJson.remind_date;
    // console.log('dateValue',dateValue,reminderJson.remind_date);
    // dateValue = (dateValue!=='')?moment(dateValue, 'YYYY-MM-DD', true).format(getDateFormat()):'';
    let timeValue = isSet(reminderJson.remind_time,null)!==null && this.props.screen!=='Steps'?reminderJson.remind_time.trim():reminderJson.remind_time;
    timeValue = (timeValue!=='')?moment(timeValue, 'hh:mm a').format('hh:mm a'):"";
    //console.log('timeValue==',timeValue);
    //console.log('this.props.screen==',this.props.screen)

    let paramState = {}
    paramState = {
      item:this.props.item,
      sectionType:isSet(this.props.screen,'Default'),
      ...this.props
    }  

    let pageScreen = this.props.screen;  
    let popupMode = this.props.popupMode || '';

    return (
      <Wrp>
        <div className="d-flex w-100 mb-3">
					<div className="input-group">
						<div className="input-group-prepend" style={{display:'inline'}}>
							<span className="input-group-text"> {`on`} </span>
						</div>

            {
              reminderJson.is_remind_date === false?
              <FormInputFields  
                type={(pageScreen==='Approval' && popupMode!=='REMINDER')?'Number':'DatePick'}
                value={dateValue}
                attributes={{
                  ...attr.fieldAttributes,
                  putDateFormat:'YYYY-MM-DD',
                  getDateFormat:'YYYY-MM-DD',
                }}
                changeHandler={(val)=>{ console.log('log...',val); this.props.actionChangeHandler({},'remind_date',val) }}
              />
              :
              <FormInputFields  
                type='StepsTypeTagForReminder'
                value={isSet(reminderJson.remind_date,[]).length>0?reminderJson.remind_date[0].name:''} 
                item={{isEditEnable:isSet(reminderJson.remind_date,[]).length>0?isSet(reminderJson.remind_date[0].is_expression,false)===true?true:false:false}}               
                changeHandler={(val)=>{ this.props.actionChangeHandler({},'remind_date',val,true,false) }}                
                editHandler = {()=>this.props.setFormulaFieldDetails({
                                    value:(isSet(reminderJson.remind_date,[]).length)>0?reminderJson.remind_date[0].value:'',
                                      conValue:isSet(reminderJson.remind_date,[{
                                          name:'',
                                          data_id:'',
                                          is_loop:false,
                                          value:'',
                                          is_window_field:false,
                                          is_variable_or_constant:false,
                                          is_expression:true
                                      }]),
                                      itmValIndex:0,
                                      drillDownOptions:this.props.item.lookupFieldsData.lookupFields.drillDownOptions,                                    
                                      updateValuesChangeHandler:(val)=>this.props.actionChangeHandlerForFormula({},'remind_date',val,true,true),
                                    conIndex:0,
                                },true)}
              />
            }
            
               
              {
                this.props.screen === 'Steps'?
                <StepsFormatTag {...this.props} handlerObj={{field_name:'remind_date'}} />
                :
                <></>
              }

					</div>	 
					<div className="input-group ml-2">
						<div className="input-group-prepend" style={{display:'inline'}}>
							<span className="input-group-text"> {`at`} </span>
						</div>

            {
              reminderJson.is_remind_time === false?
              <FormInputFields  
                type='TimePick'
                value={timeValue}
                attributes={{
                  ...attr.fieldAttributes,
                  autoComplete:'off',
                  putDateFormat:'hh:mm a',
                  getDateFormat:'hh:mm a',
                }}
                changeHandler={(time)=>{this.props.actionChangeHandler({},'remind_time',time) ; console.log(" time ====" , time);
                 }}
              />
              :
              <FormInputFields  
                type='StepsTypeTagForReminder'                
                value={isSet(reminderJson.remind_time,[]).length>0?reminderJson.remind_time[0].name:''}
                item={{isEditEnable:isSet(reminderJson.remind_time,[]).length>0?isSet(reminderJson.remind_time[0].is_expression,false)===true?true:false:false}}                            
                changeHandler={(val)=>{ this.props.actionChangeHandler({},'remind_time',val,true,false) }}
                editHandler = {()=>this.props.setFormulaFieldDetails({
                                    value:(isSet(reminderJson.remind_time,[]).length)>0?reminderJson.remind_time[0].value:'',
                                    //value:(isSet(reminderJson.remind_time,[]).length)>0?isSet(reminderJson.remind_time[0].is_expression,false)===true?reminderJson.remind_time[0].value:reminderJson.remind_time[0].variable_name:'',
                                      conValue:isSet(reminderJson.remind_time,[{
                                          name:'',
                                          data_id:'',
                                          is_loop:false,
                                          value:'',
                                          is_window_field:false,
                                          is_variable_or_constant:false,
                                          is_expression:true
                                      }]),
                                      itmValIndex:0,
                                      drillDownOptions:this.props.item.lookupFieldsData.lookupFields.drillDownOptions,                                    
                                      updateValuesChangeHandler:(val)=>this.props.actionChangeHandlerForFormula({},'remind_time',val,true,true),
                                    conIndex:0,
                                },true)}
              />
            }
            

            {
              this.props.screen === 'Steps'?
              <StepsFormatTag {...this.props} handlerObj={{field_name:'remind_time'}} />
              :
              <></>
            }

					</div>
				</div>
      </Wrp>    
    );
  }
}

OnDateOption.defaultProps = {
}

export default OnDateOption;
